/** Studio54 custom neon graphics — served from public/images/ */
export const S54 = {
  logo: '/images/studio54-logo.png',
  background: '/images/app-background.png',
  loading: '/images/Loading.png',
  defaultAlbumArt: '/images/default-album-art.png',
  defaultBookCover: '/images/unknown-book.png',
  defaultPlaylistCover: '/images/playlist-cover.jpg',
  search: '/images/search.png',
  menu: '/images/Menu.png',
  director: '/images/director.png',
  album: '/images/albumn.png',
  listen: '/images/listen.png',
  preview30s: '/images/30sec-preview.png',

  nav: {
    dashboard: '/images/Dashboard.png',
    library: '/images/Library.png',
    albums: '/images/albums-new.png',
    libraryImport: '/images/library-import.png',
    fileManagement: '/images/file-management-new.png',
    download: '/images/Download.png',
    playlists: '/images/playlists-new.png',
    soundBooth: '/images/sound-booth-new.png',
    djRequest: '/images/dj-request-new.png',
    calendar: '/images/Calendar.png',
    statistics: '/images/Statistics.png',
    downloads: '/images/Downloads.png',
    activity: '/images/activity-new.png',
    queueStatus: '/images/queue-status.png',
    settings: '/images/settings-new.png',
    howTo: '/images/how-to-new.png',
    discoLounge: '/images/disco-lounge.png',
    readingRoom: '/images/reading-room.png',
    listenAdd: '/images/listen_add.png',
  },

  player: {
    play: '/images/play.png',
    pause: '/images/pause.png',
    rewind: '/images/rewind.png',
    fastForward: '/images/FastForward.png',
    shuffle: '/images/shuffle.png',
    repeat: '/images/repeat.png',
    playlist: '/images/player-playlist.png',
    lyrics: '/images/Lyrics.png',
  },

  favSelected: '/images/fav-selected.png',
  favUnselected: '/images/fav-unselected.png',
  starSelected: '/images/star-selected.png',
  starUnselected: '/images/star-unselected.png',
} as const
